import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, Modal, Button, Form } from 'react-bootstrap';
import RefershIcon from '../../../common/assets/images/reload.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from '../../../axiosinterceptor';
import axios from 'axios';
import { base_URL } from '../../../utils/api';

const ManageCountries = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));

    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const [countries, setCountries] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingCountry, setEditingCountry] = useState(null);
    const [countryName, setCountryName] = useState('');
    const [deletingCountry, setDeletingCountry] = useState(null);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const fetchCountries = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get("/getAdminCountriesACS"); // Assuming this endpoint returns countries
                if (response.data && Array.isArray(response.data.data)) {
                    setCountries(response.data.data);
                } else {
                    setCountries([]);
                }
            } catch (error) {
                // console.error('Error fetching countries:', error);
                // toast.error('Failed to fetch countries');
                toast.error(error.response?.data?.message || "Failed to fetch countries.");
            }
            setIsLoading(false);
        };
        fetchCountries();
    }, [refresh]);

    const handleShowModal = (country = null) => {
        setEditingCountry(country);
        setCountryName(country ? country.country_name : '');
        setShowModal(true);
    };

    const handleSave = async () => {
        if (!countryName.trim()) {
            toast.error('Country name cannot be empty!');
            return;
        }

        const isDuplicate = countries.some(
            (country) =>
                country.country_name.toLowerCase() === countryName.toLowerCase() &&
                (!editingCountry || country.country_id !== editingCountry.country_id)
        );

        if (isDuplicate) {
            toast.error('Country name already exists!');
            return;
        }

        if (editingCountry) {
            try {
                const response =  await axiosInstance.put(`/updateAdminCountriesACS`, {
                    newCountryName: countryName,
                    countrieId: editingCountry.country_id,
                });
                // toast.success('Country updated successfully');
                 toast.success(response.data.message);
                setCountries((prev) =>
                    prev.map((country) =>
                        country.country_id === editingCountry.country_id ? { ...country, country_name: countryName } : country
                    )
                );
            } catch (error) {
                // console.error('Error updating country:', error);
                // toast.error('Failed to update country');
                toast.error(error.response?.data?.message || "Failed to update country.");
            }
        } else {
            try {
                const response =  await axiosInstance.post('/postAdminCountriesACS', {
                    countryName: countryName,
                });
                // toast.success('Country added successfully');
                 toast.success(response.data.message);
                setRefresh(!refresh);
            } catch (error) {
                // console.error('Error adding country:', error);
                // toast.error('Failed to add country');
                toast.error(error.response?.data?.message || "Failed to add country.");

            }
        }

        setShowModal(false);
        setRefresh(!refresh);
    };

    const handleShowDeleteModal = (country) => {
        setDeletingCountry(country);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!deletingCountry) return;

        try {
            const response =   await axiosInstance.delete(`/deleteAdminCountriesACS?countryId=${deletingCountry.country_id}`);
            // toast.success(`Country "${deletingCountry.country_name}" deleted successfully`);
             toast.success(response.data.message);
            setCountries((prev) => prev.filter((country) => country.country_id !== deletingCountry.country_id));
        } catch (error) {
            console.error('Error deleting country:', error);
            toast.error('Failed to delete country');
        }

        setShowDeleteModal(false);
        setRefresh(!refresh);
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };

    return (
        <div className="userlist-section">
            <ToastContainer autoClose={5000} />
            <div className="userlist-header">
                <h4 className="userlist-header-text">Countries</h4>
                <div className="userlist-filter-section">
                    <button className="userlist-filter-btn" onClick={() => handleShowModal()}>
                        Add Country
                    </button>
                    <span className="userlist-refresh-btn" onClick={handleRefresh}>
                        <span>
                            <img src={RefershIcon} alt="Refresh" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Country ID</th>
                            <th className="userlist-th">Country Name</th>
                            <th className="userlist-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="3">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) : countries && countries.length > 0 ? (
                            countries.map((country) => (
                                <tr key={country.country_id}>
                                    <td className="userlist-td">{country.country_id}</td>
                                    <td className="userlist-td">{country.country_name}</td>
                                    <td className="userlist-td">
                                        <FontAwesomeIcon
                                            icon={faPenToSquare}
                                            className="iconuser-update"
                                            onClick={() => handleShowModal(country)}
                                        />
                                        <FontAwesomeIcon
                                            icon={faTrash}
                                            className="iconuser-update"
                                            onClick={() => handleShowDeleteModal(country)}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingCountry ? 'Edit Country' : 'Add Country'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Country Name:</Form.Label>
                            <Form.Control
                                type="text"
                                value={countryName}
                                onChange={(e) => setCountryName(e.target.value)}
                                placeholder="Country Name"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleSave}>
                        {editingCountry ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the country "<b>{deletingCountry?.country_name}</b>"?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ManageCountries;